import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from 'primeng/button';
import { PrimengButtonDirective } from '../../directives/primeng-button.directive';
import { SlimButtonTheme } from '../../types/slim-button-theme';

@Component({
  selector: 'app-slim-button',
  imports: [CommonModule, Button, PrimengButtonDirective],
  templateUrl: './slim-button.component.html',
  styleUrl: './slim-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlimButtonComponent {
  public readonly disabled = input<boolean>(false);
  public readonly fluid = input<boolean>(true);
  public readonly loading = input<boolean>(false);
  public readonly maxWidth = input<string>('auto');
  public readonly width = input<string>('auto');
  public readonly theme = input<SlimButtonTheme>('primary');
  public readonly label = input.required<string>();
  public readonly type = input<'button' | 'submit'>('button');
  public readonly clickEvent = output<MouseEvent>();

  public handleClick($event: MouseEvent): void {
    this.clickEvent.emit($event);
  }
}
